import { createSlice } from "@reduxjs/toolkit";
import Persistor from "../store/Persistor";

const permittedActionSlice = createSlice({
  name: "permittedAction",
  initialState: {
    permittedActions: JSON.parse(Persistor.get("permittedActions") || "[]")
  },
  reducers: {
    setPermittedActions: (state, action) => {
      const permittedActions = [...action.payload.permittedActions]
      state.permittedActions = permittedActions;
      Persistor.store(
        "permittedActions",
        JSON.stringify(permittedActions)
      );
    },
  },
});
export const { setPermittedActions } = permittedActionSlice.actions;

export default permittedActionSlice.reducer;

export const selectPermittedActions = (state) => {
  return state.ui.permittedActions;
};
